import moment from 'moment'
import { getAddPuv } from 'js/addPuv.js'
import {
  getMeta
} from '../../service'
const listMixins = {
  inject: ['globalInsertRecords'],
  mixins: [getAddPuv],
  data() {
    const _that = this
    return {
      // 列表相关 变量
      listData: [],
      listLoading: true,
      total: 0,
      page_total: 0,

      //时间筛选 相关变量
      selTime: '',
      startOptions: {
        disabledDate(date) {
          if (_that.params.e_time) {
            return moment(_that.params.e_time).isBefore(date)
          } else {
            return false
          }
        }
      },
      endOptions: {
        disabledDate(date) {
          if (_that.params.s_time) {
            return moment(_that.params.s_time).isAfter(date)
          } else {
            return false
          }
        }
      },

      showAllAddress: false,
      page_modal: false,
      screen_sec: {},
      search_ipt: '',
      search_phd: '',
      hot_tag_map: [],
      meta: '',
      drop_val: false,
      screen_active: '全部'
    }
  },
  computed: {
    timeOption() {
      let end_year = moment().format('YYYY') - 0,
        begin_year = 2015,
        arr = []
      for (var i = end_year; i > begin_year - 1; i--) {
        arr.push(i)
      }
      return arr
    },
    city() {
      let address = []
      this.$store.state.address.map((a) => {
        if (a.pid == '2287') {
          address.push(a)
        }
      })
      return address
    },
    foreign_country() {
      if(this.$store.state.address) {
        return this.$store.state.address.filter(item => item.id != '2287' && item.pid == null && item.gpid == null)
      } else {
        return []
      }
    },
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    },
    default_key() {
      let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == this.position_id),
          key = ''
      if (index > -1) {
        key = this.$store.state.datahotsearchkey[index].name
      }
      return key
    },
    enter_type() {
      return this.$store.state.enter_type
    }
  },
  methods: {
    /**
     * 按需获取元数据
     */
    async getMeta(bool) {
      this.$store.state.dynview_tag_type.map((a) => {
        this.screen_sec[a.id] = false
      })
      let res = await getMeta({
        name: ['hot_tag_map']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'hot_tag_map', res.meta.hot_tag_map)
        let t_arr = []
        this.hot_tag_map.map((a) => {
          t_arr.push(a.id)
        })
        if(!bool) {
          this.getTagNum(t_arr)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    async getMeta2(arr, cb) {
      let res = await getMeta({name: arr}, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'meta', res.meta)
        if(cb) cb()
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 改变地域事件
     */
    handleChangeDemostic() {
      if (!this.listLoading) {
        this.params.address_id = []
        this.checkAll.address_id = true
        this.showAllAddress = false
        this.params.page = 1
        this.getEntityList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 点击“不限”事件
     */
    handleCheckAll(typeName, ref) {
      if (!this.listLoading) {
        if (this.checkAll[typeName]) {
          this.params[typeName] = []
        }
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 条件筛选
     */
    handleChangeOption(arr, typeName, ref) {
      if (!this.listLoading) {
        if (arr.length > 0) {
          this.checkAll[typeName] = false
        } else {
          this.checkAll[typeName] = true
        }
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 成立时间筛选
     */
    handleChangeTime(val, ref) {
      if (!this.listLoading) {
        if (val == '' || val == 'zdy') {
          this.params.year = ''
          this.params.s_time = ''
          this.params.e_time = ''
        } else {
          this.params.year = val
          this.params.s_time = ''
          this.params.e_time = ''
        }
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 点击已选择项取消事件
     */
    handleCancelOption(item, ref) {
      if (!this.listLoading) {
        switch (item.type) {
          case 'year':
            this.params.year = ''
            this.selTime = ''
            break;
          case 'quarter':
            this.params.quarter = ''
            this.selTime = ''
            break;
          case 'zdy_time':
            this.params.s_time = ''
            this.params.e_time = ''
            break;
          case 'demostic':
            this.params.demostic = null
            this.params.address_id = []
            break;
          case 'domestic':
            this.params.domestic = null
            this.params.addressIds = []
            break;
          case 's_time':
          case 'e_time':  
          case 'scope':
          case 'available':
          case 'unit_id':
          case 'province':
          case 'org':
          case 'address': // 这个address是行业数据的address
          case 'classification':
          case 'name':
          case 'compute_date':
          case 'market_id':
          case 'm_name':
          case 'is_free':
            this.params[item.type] = ''
            break;
          case 'keyword':
            this.params.keyword = ''
            this.search_ipt = ''
            break;
          case 'bidding_amount':
            this.params.bidding_amount = null
            break;
          default:
            console.log(item)
            this.params[item.type].remove(item.value)
            if (this.params[item.type].length == 0) {
              this.checkAll[item.type] = true
            }
        }
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 翻页
     */
    handleChangePage(val, no_limit) { // 第二个参数存在时，无限制
      if (val > 10 && !no_limit) {
        if (this.user) {
          if (!this.isVIP) {
            this.$refs['pages'].currentPage = this.params.page
            this.page_modal = true
          } else {
            this.params.page = val
            $('html, body').animate({
              scrollTop: 0
            }, 200)
            this.getEntityList()
          }
        } else {
          this.$refs['pages'].currentPage = this.params.page
          this.login()
        }
      } else {
        this.params.page = val
        $('html, body').animate({
          scrollTop: 0
        }, 200)
        this.getEntityList()
      }
    },
    /**
     * 列表排序功能
     */
    haddleChangeSort(val, ref) {
      if(this.sort_id != val) {
        this.sort_id = val
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      }
    },
    /**
     * 前往实体详情
     * type: 0公司 1机构 2人物 3医院
     */
    goEntityDetail(uid, type, query) {
      if (this.user_key) {
        if (type == 2) {
          // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "PeoDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 1) {
          // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "OrgDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 0) {
          // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "CompanyDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 3) {
          // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "HospitalDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 4) {
          const href = this.$store.state.index2_path + '/parkDetail/' + uid
          window.open(href, '_blank')
        }
        _czc.push(['_trackEvent', '数据', '查看分类内容总点击（' + this.listName + '）'])
      } else {
        this.login()
      }
    },
    pageCancel(value) {
      this.page_modal = value
    },
    haddleSecSel(item_id) { // 领域二级
      this.screen_sec[item_id] = !this.screen_sec[item_id]
      this.$forceUpdate()
    },
    handleSearch(val, ref) {
      if (!this.listLoading) {
        if (val) {
          this.params.keyword = val
          this.search_phd = val.length > 10 ? val.substr(0, 9).concat('...') : val
          let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == this.position_id)
          if (index > -1) {
            this.$store.state.datahotsearchkey[index].name = val
          }
          this.$store.commit('updateDatahotsearchkey', this.$store.state.datahotsearchkey)
        } else {
          this.search_ipt = this.default_key
          this.params.keyword = this.default_key
        }
        if(!ref) {
          this.params.page = 1
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    handleDropdown(val) {
      this.drop_val = val
    },
    handleDropdown2(val) {
      this.drop_val2 = val
    },
    haddleScreenDropdown(name) {
      this.screen_active = name
    },
    listenerScroll(item, size = 0) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      let bottom = scrollTop + window.innerHeight - $('.footer')[0].offsetTop + size
      if (bottom > - 1) {
        $('.' + item).css('bottom', (bottom + 20) + 'px')
      } else {
        $('.' + item).css('bottom', (20 + size) + 'px')
      }
    },
    clearGetList(e, bool) { // bool用于权限页面不执行接口
      if (!this.listLoading) {
        this.params.page = 1
        if(!bool) {
          this.getEntityList()
        }
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    goLinkDetail(row_id) {
      this.globalInsertRecords({
        content_type: 38,
        enter_type: this.enter_type,
        view_type: 1,
        content_id: row_id,
      })
      const href = this.$store.state.index2_path + '/linkDetail/' + row_id
      window.open(href, '_blank')
    },
    rowClassName (row, index) {
      return row.entity_links.length ? 'reserve' : '';
    },
  },
  created() {
    this.search_phd = this.default_key ? (this.default_key.length > 10 ? this.default_key.substr(0, 9).concat('...') : this.default_key) : '请输入关键字'
  },
  mounted() {
    let url = window.location.href
    this.getAddPuv(url)
  }
}

export {
  listMixins
}
